// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Storage = require("./storage");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Plan_iconSvg = require("./assets/plan_icon.svg");
var Checkbox_iconSvg = require("./assets/checkbox_icon.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.boxSizing(/* borderBox */9307263),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(14), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.lineHeight(1.1),
      /* :: */[
        Css.fontSize(Css.px(28)),
        /* :: */[
          Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var infoHeaderH3 = Css.style(/* :: */[
      Css.fontWeight(400),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var planIconBox = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(14)),
            /* :: */[
              Css.top(Css.px(8)),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var planIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.3,
                1.3
              ]
            ]),
        /* [] */0
      ]
    ]);

var checkboxIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.4,
                1.4
              ]
            ]),
        /* [] */0
      ]
    ]);

function horizonBox(el) {
  var match = +(el % 2 === 0);
  return Css.style(/* :: */[
              Css.textAlign(Css.center),
              /* :: */[
                Css.display(Css.flexBox),
                /* :: */[
                  match !== 0 ? Css.background(/* `hex */[
                          5194459,
                          "FFFAFA"
                        ]) : Css.background(Css.white),
                  /* :: */[
                    Css.flexDirection(Css.row),
                    /* :: */[
                      Css.alignItems(Css.center),
                      /* :: */[
                        Css.justifyContent(/* spaceBetween */516682146),
                        /* :: */[
                          Css.width(/* `percent */[
                                -119887163,
                                100.0
                              ]),
                          /* :: */[
                            Css.borderBottomLeftRadius(Css.px(10)),
                            /* :: */[
                              Css.borderBottomRightRadius(Css.px(10)),
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var horizonBoxLinks = Css.style(/* :: */[
      Css.marginTop(Css.px(20)),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.justifyContent(/* spaceAround */-485895757),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.flexWrap(/* wrap */-822134326),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutName = Css.style(/* :: */[
      Css.marginLeft(Css.px(10)),
      /* :: */[
        Css.marginRight(Css.px(4)),
        /* :: */[
          Css.textAlign(/* left */-944764921),
          /* :: */[
            Css.media("(min-width: 420px)", /* :: */[
                  Css.marginLeft(Css.px(30)),
                  /* [] */0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var doubleButton = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.marginRight(Css.px(10)),
        /* [] */0
      ]
    ]);

function smallerGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(104)),
              /* :: */[
                Css.maxWidth(Css.px(120)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(30)),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(8), Css.px(6), Css.px(0)),
                        /* :: */[
                          Css.media("(min-width: 420px)", /* :: */[
                                Css.margin4(Css.px(2), Css.px(28), Css.px(2), Css.px(0)),
                                /* [] */0
                              ]),
                          /* :: */[
                            Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                  5194459,
                                  "00C9C8"
                                ]),
                            Theme.greenSecondaryButtonRaw
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerGreenSecondaryButtonReset() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(104)),
              /* :: */[
                Css.maxWidth(Css.px(120)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(30)),
                      /* :: */[
                        Css.margin4(Css.px(6), Css.px(8), Css.px(6), Css.px(0)),
                        /* :: */[
                          Css.media("(min-width: 420px)", /* :: */[
                                Css.margin4(Css.px(2), Css.px(8), Css.px(2), Css.px(0)),
                                /* [] */0
                              ]),
                          /* :: */[
                            Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                  5194459,
                                  "00C9C8"
                                ]),
                            Theme.greenSecondaryButtonRaw
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(90)),
              /* :: */[
                Css.maxWidth(Css.px(120)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(30)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(8), Css.px(2), Css.px(0)),
                        /* :: */[
                          Css.media("(min-width: 420px)", /* :: */[
                                Css.margin4(Css.px(2), Css.px(28), Css.px(2), Css.px(0)),
                                /* [] */0
                              ]),
                          /* :: */[
                            Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                  5194459,
                                  "FF328C"
                                ]),
                            Theme.redButtonNarrowRaw
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function mediumGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(140)),
              /* :: */[
                Css.maxWidth(Css.px(170)),
                /* :: */[
                  Css.flexGrow(1),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(40)),
                      /* :: */[
                        Css.margin4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "00C9C8"
                              ]),
                          Theme.greenSecondaryButtonRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function mediumGreenSecondaryButtonLight() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(140)),
              /* :: */[
                Css.maxWidth(Css.px(170)),
                /* :: */[
                  Css.flexGrow(1),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "FABCD2"
                        ]),
                    /* :: */[
                      Css.height(Css.px(40)),
                      /* :: */[
                        Css.margin4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FABCD2"
                              ]),
                          /* :: */[
                            Css.selector("&:hover", /* :: */[
                                  Css.background(/* `hex */[
                                        5194459,
                                        "FFF"
                                      ]),
                                  /* [] */0
                                ]),
                            /* :: */[
                              Css.cursor(/* default */465819841),
                              Theme.greenSecondaryButtonRaw
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function slimButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(8.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.minHeight(Css.em(2.0)),
                  /* :: */[
                    Css.backgroundColor(Css.white),
                    /* :: */[
                      Css.color(Css.hex("fa3468")),
                      Theme.greenButtonRaw
                    ]
                  ]
                ]
              ]
            ]);
}

function slimButtonBlue() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(8.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.minHeight(Css.em(2.0)),
                  /* :: */[
                    Css.backgroundColor(Css.white),
                    /* :: */[
                      Css.color(Css.hex("71b0f9")),
                      /* :: */[
                        Css.borderColor(Css.hex("71b0f9")),
                        Theme.greenButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function slimButtonLink() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(11.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.maxWidth(Css.em(20.0)),
                  /* :: */[
                    Css.minHeight(Css.em(2.0)),
                    /* :: */[
                      Css.backgroundColor(Css.white),
                      /* :: */[
                        Css.color(Css.hex("fa3468")),
                        Theme.greenButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* headBox */headBox,
  /* contentBox */contentBox,
  /* contentContainer */contentContainer,
  /* contentHeaderBox */contentHeaderBox,
  /* contentHeaderMiddleEl */contentHeaderMiddleEl,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH3 */infoHeaderH3,
  /* planIconBox */planIconBox,
  /* planIcon */planIcon,
  /* checkboxIcon */checkboxIcon,
  /* horizonBox */horizonBox,
  /* horizonBoxLinks */horizonBoxLinks,
  /* workoutName */workoutName,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* doubleButton */doubleButton,
  /* smallerGreenSecondaryButton */smallerGreenSecondaryButton,
  /* smallerGreenSecondaryButtonReset */smallerGreenSecondaryButtonReset,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton,
  /* mediumGreenSecondaryButton */mediumGreenSecondaryButton,
  /* mediumGreenSecondaryButtonLight */mediumGreenSecondaryButtonLight,
  /* slimButton */slimButton,
  /* slimButtonBlue */slimButtonBlue,
  /* slimButtonLink */slimButtonLink
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("WorkoutWeek");

function make(week, _) {
  var syncNetworkData = function (param) {
    var send = param[/* send */4];
    var state = param[/* state */2];
    Network.initializeSyncStatus2(/* () */0);
    Network.pullData("", (function (data) {
            return Network.successSyncAllNoRedirect(data, (function () {
                          var match = state[/* isMounted */5][0];
                          if (match !== 0) {
                            return Curry._1(send, /* Loaded */1);
                          } else {
                            return /* () */0;
                          }
                        }));
          }));
    return Curry._1(send, /* Loading */2);
  };
  var checkCompleted = function () {
    var intWeek = Caml_format.caml_int_of_string(week);
    var compArr = Network.pullCompletedConfig(/* () */0);
    var one = Caml_array.caml_array_get(compArr, (1 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var two = Caml_array.caml_array_get(compArr, (2 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var three = Caml_array.caml_array_get(compArr, (3 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var four = Caml_array.caml_array_get(compArr, (4 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var match = one && two && three && four;
    if (match !== 0) {
      return /* true */1;
    } else {
      return /* false */0;
    }
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = +(Network.pullWizardConfig(/* () */0) !== /* None */0);
      if (match === 0) {
        ReasonReact.Router[/* push */0]("/wizard/1");
      }
      syncNetworkData(self);
      return /* NoUpdate */0;
    });
  newrecord[/* willUnmount */6] = (function (self) {
      self[/* state */2][/* isMounted */5][0] = /* false */0;
      return /* () */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* allCompleted */4];
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: contentBox
                        }, React.createElement("div", {
                              className: contentContainer
                            }, React.createElement("div", {
                                  className: contentHeaderBox
                                }, React.createElement("div", {
                                      className: planIconBox
                                    }, React.createElement("img", {
                                          className: planIcon,
                                          alt: "",
                                          src: Plan_iconSvg
                                        })), React.createElement("div", {
                                      className: contentHeaderMiddleEl
                                    }, React.createElement("h1", {
                                          className: infoHeaderH1
                                        }, "Workouts"), React.createElement("h3", {
                                          className: infoHeaderH3
                                        }, "Woche " + week))), $$Array.map((function (el) {
                                    var dayString = String(el);
                                    var intWeek = Caml_format.caml_int_of_string(week);
                                    var names = /* array */[
                                      "Upper Body Burn",
                                      "Leg Killer",
                                      "Upper Body & Cardio",
                                      "Lower Body Blast"
                                    ];
                                    var workoutId = (el + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0;
                                    var match = +(Caml_array.caml_array_get(self[/* state */2][/* completed */2], workoutId) === /* true */1);
                                    if (match !== 0) {
                                      return React.createElement("div", {
                                                  key: "id" + dayString,
                                                  className: horizonBox(el)
                                                }, React.createElement("h4", {
                                                      className: workoutName
                                                    }, Caml_array.caml_array_get(names, el - 1 | 0)), React.createElement("div", {
                                                      className: doubleButton
                                                    }, React.createElement("button", {
                                                          className: smallerGreenSecondaryButtonReset(/* () */0),
                                                          onClick: (function () {
                                                              return Curry._1(self[/* send */4], /* Reset */[workoutId]);
                                                            })
                                                        }, "Reset"), React.createElement("button", {
                                                          className: smallerGreenSecondaryButton(/* () */0),
                                                          onClick: (function () {
                                                              return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (dayString + "/view"))));
                                                            })
                                                        }, React.createElement("img", {
                                                              className: checkboxIcon,
                                                              alt: "",
                                                              src: Checkbox_iconSvg
                                                            }), "Ansehen")));
                                    } else {
                                      return React.createElement("div", {
                                                  key: "id" + dayString,
                                                  className: horizonBox(el)
                                                }, React.createElement("h4", {
                                                      className: workoutName
                                                    }, Caml_array.caml_array_get(names, el - 1 | 0)), React.createElement("button", {
                                                      key: "id" + dayString,
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (dayString + "/config"))));
                                                        })
                                                    }, "Starten "));
                                    }
                                  }), /* int array */[
                                  1,
                                  2,
                                  3,
                                  4
                                ]))), React.createElement("div", {
                          className: horizonBoxLinks
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/week/" + (week + "/cardio/"));
                                })
                            }, "Cardio-Workout"), match !== 0 ? React.createElement("button", {
                                className: mediumGreenSecondaryButton(/* () */0),
                                onClick: (function () {
                                    return ReasonReact.Router[/* push */0]("/week/" + (week + "/bonus/"));
                                  })
                              }, "Bonus-Workout") : React.createElement("button", {
                                className: mediumGreenSecondaryButtonLight(/* () */0)
                              }, "Bonus-Workout")), ReasonReact.element(/* None */0, /* None */0, Link.make("/dashboard", "Dashboard", someLink, /* array */[]))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* week */Storage.weekOfDay(/* () */0),
              /* day */Storage.weekDay(/* () */0),
              /* completed */Network.pullCompletedConfig(/* () */0),
              /* loading : false */0,
              /* allCompleted */checkCompleted(/* () */0),
              /* isMounted */[/* true */1]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* week */Storage.weekOfDay(/* () */0),
                          /* day */Storage.weekDay(/* () */0),
                          /* completed */Network.pullCompletedConfig(/* () */0),
                          /* loading : false */0,
                          /* allCompleted */checkCompleted(/* () */0),
                          /* isMounted */[/* true */1]
                        ],
                        (function () {
                            console.log("loaded");
                            return /* () */0;
                          })
                      ]);
          case 2 : 
              var newrecord = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord[/* loading */3] = /* true */1, newrecord),
                        (function () {
                            console.log("loading");
                            return /* () */0;
                          })
                      ]);
          
        }
      } else {
        var workoutId = action[0];
        var completedArr = Network.pullCompletedConfig(/* () */0);
        Caml_array.caml_array_set(completedArr, workoutId, /* false */0);
        var newrecord$1 = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord$1[/* completed */2] = completedArr, newrecord$1),
                  (function () {
                      console.log("resetting: ", workoutId);
                      Network.resetSingleCompletedWorkout(workoutId);
                      Network.resetSinglePoints(workoutId);
                      return Network.resetSingleReps(workoutId);
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/workoutWeek.re
// module id = 147
// module chunks = 0